// client/legend-cms/src/predictionCampaigns/index.js
import PredictionCampaignList from './PredictionCampaignList';
import PredictionCampaignCreate from './PredictionCampaignCreate';
import PredictionCampaignEdit from './PredictionCampaignEdit';
import EmojiEventsIcon from '@material-ui/icons/EmojiEvents';

const predictionCampaignsResource = {
  list: PredictionCampaignList,
  create: PredictionCampaignCreate,
  edit: PredictionCampaignEdit,
  icon: EmojiEventsIcon,
};

export default predictionCampaignsResource;
